import { useEffect, useState } from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { PageMasthead } from "@/components/ui-custom/PageMasthead";
import { RevealStagger, staggerItem } from "@/components/ui-custom/RevealOnScroll";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

const DEFAULTS = {
  contact_address: "Tingkat 1, Sublot 47, Matang Hub, 93050 Kuching, Sarawak",
  contact_email: "bodyguardsarawak@gmail.com",
  contact_phone: "082-544018 / 019-8766656",
};

export default function Hubungi() {
  const [orgInfo, setOrgInfo] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/public/org-info").then((r) => {
      setOrgInfo({
        contact_address: r.data.contact_address || DEFAULTS.contact_address,
        contact_email: r.data.contact_email || DEFAULTS.contact_email,
        contact_phone: r.data.contact_phone || DEFAULTS.contact_phone,
      });
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="hubungi-page">
      <PageMasthead breadcrumb="HUBUNGI" title="Hubungi PPPS" subtitle="Kami sedia membantu sebarang pertanyaan berkaitan keahlian." />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <RevealStagger className="grid sm:grid-cols-3 gap-6" staggerDelay={0.1}>
          <motion.div variants={staggerItem} className="p-7 rounded-xl bg-white border border-piks-border hover:border-piks-gold/40 hover:-translate-y-1 transition-all duration-300" data-testid="contact-address">
            <MapPin className="w-6 h-6 text-piks-red mb-4" />
            <h3 className="font-semibold text-piks-black mb-2">Alamat Pejabat</h3>
            <p className="text-sm text-piks-muted leading-relaxed whitespace-pre-line">{orgInfo.contact_address}</p>
          </motion.div>
          <motion.div variants={staggerItem} className="p-7 rounded-xl bg-white border border-piks-border hover:border-piks-gold/40 hover:-translate-y-1 transition-all duration-300" data-testid="contact-email">
            <Mail className="w-6 h-6 text-piks-red mb-4" />
            <h3 className="font-semibold text-piks-black mb-2">Emel Urusetia</h3>
            <p className="text-sm text-piks-muted">{orgInfo.contact_email}</p>
          </motion.div>
          <motion.div variants={staggerItem} className="p-7 rounded-xl bg-white border border-piks-border hover:border-piks-gold/40 hover:-translate-y-1 transition-all duration-300" data-testid="contact-phone">
            <Phone className="w-6 h-6 text-piks-red mb-4" />
            <h3 className="font-semibold text-piks-black mb-2">Talian Pejabat</h3>
            <p className="text-sm text-piks-muted">{orgInfo.contact_phone}</p>
            <p className="text-xs text-piks-muted mt-1">Isnin - Jumaat, 8:30am - 5:30pm</p>
          </motion.div>
        </RevealStagger>
      </section>
    </div>
  );
}
